import React from 'react'
import { Box } from 'theme-ui'

const LayoutSkipLink = () => (
  <Box
    sx={{
      a: {
        background: '#FFFCFA',
        boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.2)',
        fontSize: '16px',
        fontWeight: 'bold',
        height: '56px',
        left: '0',
        padding: '8px 24px',
        position: 'absolute',
        transform: 'translateY(-500px)',
        zIndex: '1000',
        '&:focus': {
          transform: 'translateY(0px)',
        },
      },
    }}
  >
    <a href="#main">{'Skip to main content'}</a>
  </Box>
)

export default LayoutSkipLink
